D.StickyHeader = Class(
	/**
	 * @lends {D.StickyHeader#}
	 */
	{
		lastScrollTop: 0,
		timeout: null,

		/**
		 * @param {Node} header
		 * @constructs
		 */
		__construct: function(header){
			this.header = header;
			this.height = header.offsetHeight;

			$(window).scroll(this._scroll);
		},

		_debounce: function() {
			if( this.timeout ){
				clearTimeout(this.timeout);
			}
			this.timeout = setTimeout(this._scroll, 16);
		},

		_scroll: function() {
			let currScrollTop = Math.max(0, document.documentElement.scrollTop || document.body.scrollTop || 0);
			let isScrollingDown = currScrollTop > this.lastScrollTop;
			let isHeaderVisible = currScrollTop < this.header.offsetHeight;

			if( currScrollTop > this.height ){
				addClassName(this.header, 'scrolled');
				addClassName(document.body, 'header-scrolled');
			}else{
				removeClassName(this.header, 'scrolled');
				removeClassName(document.body, 'header-scrolled');
			}

			if( (isScrollingDown && !isHeaderVisible) || D.isClosingMenu ){
				setTimeout(function(){
					D.isClosingMenu = false;
				}, 10);
				addClassName(this.header, 'is-hidden');
				addClassName(document.body, 'header-is-hidden');
			}else{
				removeClassName(this.header, 'is-hidden');
				removeClassName(document.body, 'header-is-hidden');
			}
			this.lastScrollTop = currScrollTop;
		}
	}
);
D.StickyHeader.inst = null;
